
export const CapabilityName = {   
    BackSplash : 'backsplash',
    Loader : 'loader',
    Modal: 'modal',
    Notification: 'notification',
    ReleaseNotes: 'releasenotes',
}

export const Features = {
    Eyemark: 'Eyemark',
    BottomFill: 'BottomFill',
    TearNotch: {
        Name: 'TearNotch',
        RelatedFeatureName: 'TearNotchOffset'
    },
    HangHole: {
        Name: 'HangHole',
        RelatedFeatureName: 'HangHoleOffset'
    },
    Vent: {
        Name: 'Vent',
        RelatedFeatureName: 'VentOffset'
    },
    Zipper: {
        Name: 'Zipper',
        RelatedFeatureName: 'ZipperOffset'
    }
}
